<template>
    <div>
        <div class="example-simple mb-2">
            <div class="upload d-flex">
                <div class="example-btn mr-2 d-flex">
                    <!-- 
                    :size="1024 * 1024 * 10" 
                    :extensions="extension ? [extension] : ['gif','jpg','jpeg','png','webp']"
                    -->

                    <div class="mr-2" v-if="!blockcam" :class="btnlinha ? 'd-flex' : ''">
                        <div>
                            <button type="button" class="btn btn-outline-secondary mb-1" :class="btnlinha ? 'btn-sm' : ''" @click="capturarDaCamera()">
                                <i class="fa fa-camera fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>

                        <template v-if="logo || arquivo">
                            <div>
                                <a :href="logo 
                                    ? logo.arquivo.temporary_url
                                    : ( arquivo ? arquivo.arquivo.temporary_url : '#' )" target="_blank" type="button" 
                                    class="btn btn-outline-secondary mb-1 ml-1"
                                    :class="btnlinha ? 'btn-sm' : ''">
                                    <i class="fa-solid fa-magnifying-glass-plus fa-fw"></i>
                                </a>
                            </div>

                            <div>
                                <button type="button" class="btn btn-outline-danger mb-1 ml-1" 
                                    @click="removeFile ()"
                                    :class="btnlinha ? 'btn-sm' : ''">
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </div>

                    <file-upload v-show="!logo && !arquivo"
                        class="btn btn-primary mb-1"
                        post-action="http://52.201.90.35/api/upload_arquivo_atendimento"
                        :extensions="extension ? [extension] : ['gif','jpg','jpeg','png','webp','pdf']"
                        :accept="mimetype ? mimetype : 'image/png,image/gif,image/jpeg,image/webp' + ( pode_pdf ? ',application/pdf' : '' )"
                        :input-id="'file-' + service + ( chave ? '-' + chave : '' )"
                        :name="nameFileInput"
                        :data="{ ...parms }" 
                        :headers="{ ...this.axios.defaults.headers.post }"
                        :multiple="false"
                        :size="1024 * 1024 * 10 || 0"
                        :custom-action="azUpload"
                        v-model="files"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        :ref="refname">
                        <div v-if="$refs[refname] && $refs[refname].active">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            Enviando...
                        </div>
                        <span v-else class="text-nowrap text-truncate">
                            <i class="fa fa-plus mr-1"></i>
                            {{ titulo ? titulo : 'Logo' }}
                        </span>
                    </file-upload>

                    <div v-if="logo || arquivo">
                        <div v-if="$refs[refname] && $refs[refname].active">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            Enviando...
                        </div>

                        <div v-else>
                            <div v-if="showlink">
                                <div> 
                                    <button type="button" class="btn btn-outline-danger mr-1" @click="removeFile ()">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-primary" @click="viewFile ()">
                                        Visualizar
                                    </button>
                                </div>
                            </div>
                            <a :href="logo.arquivo.temporary_url" target="_blank" v-else-if="logo && logo.arquivo && logo.arquivo.st_tipo_arquivo == 'pdf'">
                                <i class="fa-solid fa-file-pdf fa-2x"></i> Visualizar
                            </a>
                            <a :href="arquivo.arquivo.temporary_url" target="_blank" v-else-if="arquivo && arquivo.arquivo && arquivo.arquivo.st_tipo_arquivo == 'pdf'">
                                <i class="fa-solid fa-file-pdf fa-2x"></i> Visualizar
                            </a>
                            <template v-else-if="extension != 'pfx'">
                                <a href="#" @click.prevent="escolherArquivo()">
                                    <img :src="logo.arquivo && logo.arquivo.temporary_url" class="img-fluid img-thumbnail" v-if="logo" 
                                        style="max-width: 200px; max-height: 130px;">
                                    <img :src="arquivo.arquivo && arquivo.arquivo.temporary_url" class="img-fluid img-thumbnail" v-else-if="arquivo"
                                        style="max-width: 200px; max-height: 130px;">
                                </a>

                                <template v-if="!block_size_alert">
                                    <div v-if="logo && logo.arquivo && logo.arquivo.in_tamanho">
                                        <div v-if="logo.arquivo.in_tamanho > 51200">
                                            <a href="#" @click.prevent="info_arquivo_grande(logo.arquivo)">
                                                <i class="fa-solid fa-triangle-exclamation text-warning"></i>
                                                Arquivo com +50Kb
                                            </a>
                                        </div>
                                        <div class="small text-muted">
                                            {{ Math.round(logo.arquivo.in_tamanho / 1024) }}Kb
                                        </div>
                                    </div>

                                    <div v-if="arquivo && arquivo.arquivo && arquivo.arquivo.in_tamanho">
                                        <div v-if="arquivo.arquivo.in_tamanho > 51200">
                                            <a href="#" @click.prevent="info_arquivo_grande(arquivo.arquivo)" class="card-link">
                                                <i class="fa-solid fa-triangle-exclamation text-warning"></i>
                                                <strong class="small">
                                                    Arquivo com +50Kb
                                                </strong>
                                            </a>
                                        </div>
                                        <div class="small text-muted">
                                            {{ Math.round(arquivo.arquivo.in_tamanho / 1024) }}Kb
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="modalWebCam" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Capturar</h5>
                        <button type="button" class="close" @click="fecharcamera()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- WebCam -->
                        <div class="border" v-if="usewebcam">
                            <div class="row">
                                <div class="col-md-6">
                                    <code v-if="device">{{ device.label }}</code>
                                    <div class="border">
                                        <vue-web-cam
                                            ref="webcam"
                                            :device-id="deviceId"
                                            width="100%"
                                            @started="onStarted"
                                            @stopped="onStopped"
                                            @error="onError"
                                            @cameras="onCameras"
                                            @camera-change="onCameraChange"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6 d-flex flex-column justify-content-between">
                                    <code v-if="device">Imagem Capturada</code>
                                    <figure class="figure">
                                        <img :src="img" class="img-responsive figure-img img-fluid rounded" />
                                    </figure>
                                    <div>
                                    <select v-model="camera" class="form form-control">
                                        <option>-- Selecione a fonte de vídeo --</option>
                                        <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">{{ device.label }}</option>
                                    </select>
                                    <div class="d-flex flex-column">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-success" @click="onStart" v-if="!opencam">
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button type="button" class="btn btn-danger" @click="onStop" v-else>
                                            <i class="fas fa-stop mr-2"></i>Parar
                                        </button>
                                        <button type="button" class="btn btn-dark" @click="onCapture" v-if="opencam">
                                            <i class="fas fa-camera mr-2"></i>Capturar
                                        </button>
                                        <button type="button" class="btn btn-primary" @click="selecionarCaptura" :disabled="!img || enviando" v-if="opencam">
                                            <i class="fas fa-mouse-pointer mr-2"></i>Selecionar
                                        </button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fecharcamera()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="small text-muted" v-if="id_arquivo">id: {{ id_arquivo }}</div>

        <!-- Arquivo Grande -->
        <div class="modal fade" :id="'arquivoGrande' + modalname" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Arquivo Grande</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="arquivo_grande">
                        <div class="alert alert-warning d-flex justify-content-between" v-if="arquivo_grande.in_tamanho > 51200">
                            <div>
                                <i class="fa-solid fa-triangle-exclamation text-warning"></i>
                                <strong class="small">
                                    Arquivo com +50Kb
                                </strong>
                            </div>
                            <div class="small text-muted" v-if="arquivo_grande.in_tamanho">
                                {{ Math.round(arquivo_grande.in_tamanho / 1024) }}Kb
                            </div>
                        </div>

                        <div class="alert alert-warning">
                            Considere otimizar o tamanho da imagem com eventua compressão ou redimensionamento para melhorar o desempenho e reduzir o tempo de carregamento, utilizando o 
                            <a href="https://www.iloveimg.com/compress-image" target="_blank">iloveimg</a>.
                        </div>

                        <div class="text-center card-link">
                            <a :href="arquivo_grande && arquivo_grande.temporary_url" :download="arquivo_grande.st_titulo" target="_blank">
                                Download do Arquivo
                            </a>
                        </div>
                        
                        <div class="text-center">
                            <img :src="arquivo_grande && arquivo_grande.temporary_url" class="img-fluid img-thumbnail" v-if="arquivo_grande">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import { WebCam } from "vue-web-cam";

export default {
    data: function () {
        return {
            files: [],
            logo: null, 
            enviando: false, 
            usewebcam: false, 

            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            opencam: false,

            arquivo_grande: null, 
        }
    },

    components: { 
        "vue-web-cam": WebCam,
    },

    props: [
        'parms', 
        'arquivos', 
        'arquivo', 
        'single', 
        'service', 
        'titulo', 
        'showlink', 
        'chave', 
        'extension',
        'mimetype',
        'blockcam',
        'id_arquivo', 
        'pode_pdf', 
        'btnlinha', 
        'block_size_alert'
    ],

    computed: { 
        modalname: function() { 
            return 'modalCamera' + this.refname;
        },

        refname: function () { 
            return 'upload_' + this.service + ( this.chave ? '_' + this.chave : '' );
        },

        nameFileInput: function () { 
            return 'file-' + this.service + ( this.chave ? '-' + this.chave : '' );
        },

        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
    },

    watch: { 
        files: function (newValue) { 
        
            if ( newValue && newValue.length == 1 && newValue[0].success && this.service && this.parms.model_id > 0 ) { 

                if ( _.get(this.parms, 'tipo_especial') ) 
                    return;

                let query = { q: [ 
                    {
                        name: this.service + '.show',
                        id: 'logo',
                        parms: { 
                            id: this.parms.model_id,
                            cadastro: true, 
                            ...this.parms, 
                        }
                    }
                ]};

                this.axios.post( '/aql', query)
                   .then(res => {
                        if ( this.mimetype ) { 
                           this.$emit('refresh');
                        } else { 
                            this.logo = res.data.logo.data.logo;
                        }
                        
                        this.files = [];
                    });

            }
        },

        camera: function(id) {
            this.deviceId = id;
        },

        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
            console.log(tail);
        },
    },

    methods: {
        info_arquivo_grande (arq) { 
            this.arquivo_grande = _.cloneDeep(arq);
            $('#arquivoGrande' + this.modalname).modal('show');
        },

        fecharcamera() { 
            $('#modalWebCam').modal('hide');
        },

        capturarDaCamera() { 
            this.usewebcam = true;
            $('#modalWebCam').modal('show');
        },

        // Métodos para Captura de Imagem
        onCapture() {
            this.img = this.$refs.webcam.capture();
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
            this.opencam = true;
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
            this.opencam = false;
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },

        selecionarCaptura () { 
            //console.log(this.img);

            let filename = 'image.jpg';
            let dataurl = this.img;

            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
                
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            
            let novo = new File([u8arr], filename, {type:mime});

            this.$refs[this.refname].add(novo);

        },
        
        escolherArquivo () { 
            $('#' + this.nameFileInput).click();
        },

        viewFile (id = null) { 

            if ( !id && this.arquivo ) 
                id = this.arquivo.id_arquivo;

            console.log(this.arquivo);
            
            this.$store.commit('loading', true);

            let dados = { 
                id: id
            };

            this.axios.post('/arq', dados)
                .then(res => { 
                    window.open(res.data, '_blank');
                    console.log('Link', res.data);
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },

        removeFile () { 

            if ( !confirm ('Confirma remover o arquivo?') )
                return;

            console.log('rem', this.arquivo);

            let id = this.arquivo.id_arquivo_link;

            this.$store.commit('loading', true);

            let dados = { 
                id: id
            };

            this.axios.post('/arq/remove', dados)
                .then(() => { 
                    this.arquivo = null;
                    this.logo = null; 

                    this.$emit('sync', this.logo);
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                console.log('response', newFile.response)
                if (newFile.xhr) {
                    //  Get the response status code
                    console.log('status', newFile.xhr.status)
                }
            }

            this.$refs[this.refname].active = true
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if ( this.extension == 'pfx' ) { 
                    if (!/\.(pfx)$/i.test(newFile.name)) {
                        return prevent()
                    }
                } else { 
                    if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            }

            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },

        abrir () { 
            this.files = [];
            $('#fileUploadModal').modal('show');
        },

        async azUpload(file, component) {
            let formData = new FormData();
            
            if ( this.parms ) { 
                _.forEach(this.parms, function (element, key) { 
                    formData.append(key, element);    
                });
            }

            console.log('File', file);
            console.log('File', component);

            this.enviando = true;

            formData.append('file', file.file);

            let url =
                this.parms && this.parms.token
                    ? "upload_arquivo_token"
                    : "upload_arquivo_atendimento";

            return this.axios.post(url,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(res => {
                    if ( res.data.status > 400 ) { 
                        window.app.handleError({ 
                            response: { 
                                status: res.data.status,
                                data: { 
                                    errors: res.data.error
                                }
                            }
                        });
                    } else { 
                        this.logo = res.data;
                        this.$emit('sync', this.logo);
                        this.fecharcamera();
                        return res;
                    }
                })
                .finally(() => { 
                    this.enviando = false;
                });
        }
    },

    mounted() { 
        $('#modalWebCam').on('hidden.bs.modal', () => {
          this.usewebcam = false;
        });

        if ( this.id_arquivo ) { 
            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'show', 
                parms: { 
                    id: this.id_arquivo
                }
            })
            .then(res => { 
                this.logo = { arquivo: res };
            });
        }
    }
}
</script>